import React, { Component } from "react";
import { Div, Icon, Modal } from "atomize";
import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";

const fullVideoParams = {
  fluid: false,
  playsInline: true,
  autoPlay: true,
  isFullscreen: true,
};

class HomeFullVideoModal extends Component {
  constructor(props) {
    super(props);

    this.fullVideoPlayer = React.createRef();
  }

  // pause = () => {
  //   // this.fullVideoPlayer.current.pause();
  // };

  onEntering = () => {
    // this.fullVideoPlayer.current.toggleFullscreen();
    // console.log(this.fullVideoPlayer.current);
  };

  render() {
    const { isOpen, onClose, card } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        onEntering={this.onEntering}
        align="center"
        maxW={{ xs: "calc(100% - 2rem)", md: "calc(100% - 2rem)", lg: "59rem" }}
        p="0"
        textColor="black"
        rounded="sm"
        shadow="modalShadow"
        overflow="visible"
        m={{ xs: "2rem 1rem 1rem", md: "1rem", lg: "auto" }}
      >
        <Icon
          d={{ xs: "none", lg: "block" }}
          name="Cross"
          pos="absolute"
          top="0.75rem"
          right="1rem"
          size="28px"
          onClick={onClose}
          cursor="pointer"
          color="black"
          zIndex="100"
        />
        <Icon
          d={{ xs: "block", lg: "none" }}
          name="Cross"
          pos="absolute"
          top="-2rem"
          right="-0.5rem"
          size="28px"
          onClick={onClose}
          cursor="pointer"
          color="white"
          zIndex="100"
        />
        <Div>
          <Div pos="relative" bg="black" p={{ b: "56.3%" }}>
            <Div
              pos="absolute"
              top="0"
              left="0"
              w="100%"
              h="100%"
              d="flex"
              align="center"
              zIndex="1"
            >
              <Player
                {...fullVideoParams}
                ref={this.fullVideoPlayer}
                className="video-modal"
              >
                <source src={card.video.file.url} />
                <ControlBar>
                  <CurrentTimeDisplay order={4.1} />
                  <TimeDivider order={4.2} />
                  <VolumeMenuButton order={8} />
                </ControlBar>
              </Player>
            </Div>
          </Div>
        </Div>
      </Modal>
    );
  }
}

export default HomeFullVideoModal;
